import { CSSProperties } from 'react';

import styled from 'styled-components';
import { color } from 'styled-system';

type ContainerProps = {
  $marginLeft?: string;
  $marginRight?: string;
  $event?: CSSProperties['pointerEvents'];
  $cursor?: CSSProperties['cursor'];
};

export const Container = styled.div<ContainerProps>`
  ${color}

  display: inline-flex;
  cursor: ${({ $cursor }) => $cursor ?? 'pointer'};

  margin-left: ${({ $marginLeft }) => $marginLeft ?? '0px'};
  margin-right: ${({ $marginRight }) => $marginRight ?? '0px'};
  pointer-events: ${({ $event }) => $event ?? 'auto'};
`;
